import { Box, Button, Grid } from "@mui/material";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import BusinessProfileModal from "../employeeInfo/businessProfileModal";
import { useState } from "react";
import ElegentProfileModal from "../employeeInfo/ElegentPrimeProfileModal";
import Busi from "../../assets/icon/ShareMessageContainer/BusinessProfile.png";
import Elepr from "../../assets/elepr.png";
import Emp from "../../assets/icon/ShareMessageContainer/EmployeeProfile.png";
import Msg from "../../assets/icon/ShareMessageContainer/singleMessage.png";
import Rate from "../../assets/icon/ShareMessageContainer/RateCard.png";
import BulkMe from "../../assets/icon/ShareMessageContainer/BulkMessages.png"
import qout from "../../assets/icon/ShareMessageContainer/Quotation.png"
import { setBarName } from "../../app/store/reducer";
import { useDispatch } from "react-redux";
import { ArrowBackIcon } from "../../common/icon";

export const ShareMessageContainer = () => {
  const navigate = useNavigate();
    const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [openT, setOpenT] = useState(false);
  return (
    <Grid
      container
      spacing={2}
      sx={{
        p: "10px",
        backgroundColor: "#EAE9FF",
        height: "102vh",
      }}
    >
      <Grid container xs={12}>
        <Grid
          item
          xs={1}
          px={2}
          py={3}
          display="flex"
          justifyContent="center"
          alignItems="flex-start"
        >
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/home")}
          />
        </Grid>
        <Grid item xs={11}>
          <Grid container spacing={2} p={{ xs: 2, sm: 4 }}>
            {[
              {
                label: "Share Bulk Messages (Paid)",
                onClick: () => {
                  navigate(routePath.BULTMESSAGE);
                },
                img: BulkMe,
              },
              {
                label: "Share Single Message (Free)",
                onClick: () => {
                  dispatch(setBarName("CustomerMangment"));
                  navigate(routePath.SHARESESSAGE);
                },
                img: Msg,
              },
              {
                label: "Share Rate Card",
                onClick: () => {
                  dispatch(setBarName("CustomerMangment"));
                  navigate(routePath.SHARERATECARD);
                },
                img: Rate,
              },
              {
                label: "Share Quotations",
                onClick: () => {
                  dispatch(setBarName("CustomerMangment"));
                  navigate(routePath.SHARERATECARD);
                },
                img: qout,
              },
              {
                label: "Share Business Profile",
                onClick: () => {
                  setOpen(true);
                },
                img: Busi,
              },
              {
                label: "Share Employee Profile",
                onClick: () => {
                  dispatch(setBarName("CustomerMangment"));
                  navigate(routePath.SHAREMESSAGEPROFILE);
                },
                img: Emp,
              },
              {
                label: "Share Elegent Prime Profile",
                onClick: () => {
                  setOpenT(true);
                },
                img: Elepr,
              },
            ].map((item, index) => (
              <Grid item xs={12} sm={6} px={{ xs: 1, sm: 3 }} key={index}>
                <Button
                  variant="outlined"
                  fullWidth
                  sx={{
                    height: "50px",
                    width: "100%",
                    // fontSize: "16px",
                    // textTransform: "none",
                    backgroundColor: "#01008B",
                    border: "2px solid #01008B",
                    color: "#FFFFFF",
                    fontWeight: 600,
                    fontSize: { xs: "12px", sm: "13px", md: "17px" },
                    transition: "0.3s",
                    // "&:active": { transform: "scale(0.95)" },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "12px",
                    "&:hover": {
                      backgroundColor: "#01008B",
                      border: "2px solid #01008B",
                      boxShadow: "none",
                    },
                  }}
                  onClick={item.onClick}
                >
                  <Box
                    component="img"
                    src={item.img}
                    alt={item.label}
                    sx={{
                      height: { xs: 30, sm: 40 },
                      width: { xs: 30, sm: 40 },
                      alignSelf: "flex-start",
                    }}
                  />
                  <span style={{ flex: 1, textAlign: "center" }}>
                    {item.label}
                  </span>
                </Button>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>

      <BusinessProfileModal
        config={{ share: true }}
        open={open}
        setOpen={setOpen}
      />
      <ElegentProfileModal open={openT} setOpen={setOpenT} />
    </Grid>
  );
};
